export default {
    defaultDateTimeFormat: 'YYYY-MM-DD HH:mm',
    databaseDateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    submissionCanEditByDays: 45,
    domainUrl: 'https://datatool.workitaround.com',
    roles: {
        ADMIN: 1,
        RECYCLER: 2,
        AUDITOR: 3,
        REPRESENTATIVE: 4,
        SECTOR_ASSOCIATION_REPRESENTATIVE: 5,
    },
    sectorAssociation: {
        PIPES: {
            id: 1,
            name: 'Pipes',
        },
        FLOORING: {
            id: 2,
            name: 'Flooring',
        },
        ROOFING_OR_WATERPROOFING: {
            id: 3,
            name: 'Roofing/waterproofing',
        },
        PROFILES: {
            id: 4,
            name: 'Profiles',
        },
        CABLES: {
            id: 5,
            name: 'Cables',
        },
        FILMS_AND_SHEETS: {
            id: 6,
            name: 'Films and sheets'
        },
    },
    sectorAssociationValue: {
        INTERNAL: 'internal',
        EXTERNAL: 'external',
    },
    regions: {
        'At + Ch': 'At + Ch',
        'Benelux': 'Benelux',
        'Eastern Europe': 'Eastern Europe',
        'France': 'France',
        'Germany': 'Germany',
        'Iberia': 'Iberia',
        'Italy': 'Italy',
        'Poland': 'Poland',
        'Scandinavia': 'Scandinavia',
        'United Kingdom': 'United Kingdom',
    }
};
